import { Instance, Instances, useGLTF, useTexture } from '@react-three/drei';
import { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';

// Preload the HighChair model
useGLTF.preload('/env/HighChair.glb');

export function HighChair({ jsonFile, texturePath }) {
    const { nodes } = useGLTF('/env/HighChair.glb', true, (error) => {
        console.error('Failed to load model', error)
    })

    // Preload the texture
    useTexture.preload(texturePath);

    // Load and configure the plant texture
    const HighChairtexture = useTexture(texturePath)
    HighChairtexture.colorSpace = THREE.SRGBColorSpace
    HighChairtexture.flipY = false
    HighChairtexture.channel = 1
    HighChairtexture.generateMipmaps = false

    // Create a static MeshBasicMaterial
    const material = useMemo(
        () =>
            new THREE.MeshBasicMaterial({
                 toneMapped: false,side:THREE.DoubleSide, transparent:true, map:HighChairtexture

            }),
        [texturePath]
    )

    // State to store instance data
    const [data, setData] = useState([])

    useEffect(() => {
        fetch(jsonFile)
            .then(response => response.json())
            .then(jsonData => {
                const parsedData = Object.values(jsonData).map((entry) => ({
                    position: mapAxes(entry.position || [0, 0, 0]),
                    scale: mapScale(entry.scale || [0, 0, 0]),
                    rotation: mapRotation(entry.rotation || [0, 0, 0]),
                }));
                setData(parsedData);
            })
            .catch(error => console.error('Error loading JSON:', error));
    }, [jsonFile])

    return (
        data.length > 0 && (
            <Instances
                range={data.length}
                geometry={nodes.mainHighChair.geometry}
                material={material}
            >
                {data.map((props, i) => (
                    <HighChairs key={i} {...props} />
                ))}
            </Instances>
        )
    )
}

function HighChairs({ position, scale, rotation }) {
    const ref = useRef()
    return (
        <group
            position={position}
            scale={scale}
            rotation={rotation}
        >
            <Instance ref={ref} />
        </group>
    )
}

// Function to remap Blender axes to Three.js axes
function mapAxes([x, y, z]) {
    return [x, z, -y] 
  }
  
  function mapRotation([rx, ry, rz]) {
    return [rx, rz,-ry] 
  }
  function mapScale([rx, ry, rz]) {
    return [rx, ry, rz] 
  }